<template>
  <el-dialog
    :visible="visible"
    title="加入货物"
    destroy-on-close
    width="1000px"
    class="add-cargo-form"
    @close="onClose"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="50px"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col
          :span="20"
          style="margin-top:0"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                label="供应商"
                prop="supplierId"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Company"
                  filterable
                  :default-value="form.supplierId||''"
                  tag-name="chineseName"
                  style="width:100%;"
                  :method-params="{tradersSign:true}"
                  @parentCallBack="p=>form.supplierId=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="生产商"
                prop="producerId"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Company"
                  filterable
                  :default-value="form.producerId||''"
                  tag-name="chineseName"
                  style="width:100%;"
                  :method-params="{factorySign:true}"
                  @parentCallBack="p=>form.producerId=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="来源"
                prop="source"
              >
                <el-input v-model="form.source" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                label="起运港"
                prop="pol"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="form.pol"
                  style="width:100%"
                  @parentCallBack="p=>form.pol=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="目的港"
                prop="pod"
              >
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-value="form.pod"
                  style="width:100%"
                  @parentCallBack="p=>form.pod=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="预计货好时间"
                prop="estimatedIncomeDate"
              >
                <el-date-picker
                  v-model="form.estimatedIncomeDate"
                  type="daterange"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                label="订单号"
                prop="poNos"
              >
                <cargo-multi-line-text-popover
                  ref="poInput"
                  input-width="100%"
                  :value.sync="form.poNos"
                  show-popover
                  :visible-arrow="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="SKU号"
                prop="itemNo"
              >
                <el-input v-model="form.itemNo" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="包装创建日期"
                prop="createDate"
              >
                <el-date-picker
                  v-model="form.createDate"
                  type="daterange"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-form-item label-width="0">
            <el-button
              type="primary"
              @click="handleQuery(1)"
            >搜索</el-button>
            <el-button @click="handleImport">导入</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="display: flex;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :row-data="rowData"
        :column-defs="columnDefs"
        style="width:100%;min-height: 300px"
        @gridReady="params=>gridOptions.columnApi=params.api"
      />
    </div>
    <div>
      <el-form>
        <cargo-pagination
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          @pagination="()=>handleQuery()"
        />
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import ColumnUtils from '@/utils/ColumnUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoMultiLineTextPopover from '@/components/Cargo/Common/cargoMultiLineTextPopover'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import {
  queryNeedWarehouseInPackageList,
  addPackageToWarehouseIn
} from '@/api/OMS/warehouseIn'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  name: 'AddCargo',
  components: { cargoAdvanceSelect, cargoMultiLineTextPopover },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    warehouseInUuid: { type: String, default: () => '' }
  },
  data() {
    return {
      TYPE_NAMES,
      form: {
        supplierId: '',
        producerId: '',
        source: '',
        pol: '',
        pod: '',
        estimatedIncomeDate: [],
        poNos: '',
        itemNo: '',
        createDate: []
      },
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        columnApi: null,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: (item) => {
            const { data } = item
            if (!data.packageNo) {
              return false
            }
            return true
          },
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '包装号',
          field: 'packageNo',
          width: 150
        },
        {
          headerName: '包装类型',
          field: 'packageType',
          width: 150
        },
        {
          headerName: '包装数(预)',
          field: 'estimatedQuantity',
          width: 150
        },
        {
          headerName: '订单号',
          field: 'poNo',
          width: 150
        },
        {
          headerName: 'SKU编码',
          field: 'itemNo',
          width: 150
        },
        {
          headerName: 'SKU数量',
          field: 'itemQuantity',
          width: 150
        },
        {
          headerName: '生产商',
          field: 'producerName',
          width: 150
        },
        {
          headerName: '预计货好时间',
          field: 'estimatedIncomeDate',
          width: 150
        },
        {
          headerName: '来源',
          field: 'sourceFileName',
          width: 150
        },
        {
          headerName: '注意事项',
          field: 'matters',
          width: 150
        },
        {
          headerName: '包装创建日期',
          field: 'dateCreated',
          width: 150
        },
        {
          headerName: '起运港',
          field: 'loadingPortCode',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(
              this.TYPE_NAMES.basic_data_Seaport,
              'code',
              params.value,
              'englishName'
            )
          }
        },
        {
          headerName: '目的港',
          field: 'destinationPortCode',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(
              this.TYPE_NAMES.basic_data_Seaport,
              'code',
              params.value,
              'englishName'
            )
          }
        },
        {
          headerName: '供应商',
          field: 'supplierName',
          width: 150
        },
        {
          headerName: '状态',
          field: 'stateName',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            let stateName = ''
            switch (data.state) {
              case -1:
                stateName = '已取消'
                break
              case 0:
                stateName = '操作中'
                break
              case 1:
                stateName = '已完成'
                break
            }
            return stateName
          }
        }
      ]
    }
  },
  watch: {
    /* visible(newVal) {
      if (newVal) {
        this.fetchList()
      }
    }*/
  },
  methods: {
    fetchList() {
      this.loading = getLoading()
      const params = {
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      Object.keys(this.form).forEach((key) => {
        if (this.form[key]) {
          if (key === 'estimatedIncomeDate') {
            const { estimatedIncomeDate } = this.form
            if (estimatedIncomeDate.length !== 0) {
              params.estimatedIncomeDateFrom = estimatedIncomeDate[0]
              params.estimatedIncomeDateTo = estimatedIncomeDate[1]
            }
          } else if (key === 'createDate') {
            const { createDate } = this.form
            if (createDate.length !== 0) {
              params.createDateFrom = createDate[0]
              params.createDateTo = createDate[1]
            }
          } else {
            params[key] = this.form[key]
          }
        }
      })
      console.log(params)
      queryNeedWarehouseInPackageList(params)
        .then((res) => {
          this.rowData = res.data.list
          this.filter.total = Number(res.data.total)
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    onClose() {
      this.handleReset()
      this.rowData = []
      this.$emit('onClose')
    },
    handleQuery(type = 0) {
      if (type !== 0) {
        this.filter.pageNum = 1
      }
      this.fetchList()
    },
    handleReset() {
      this.$refs['form'].resetFields()
    },
    handleImport() {
      const { columnApi } = this.gridOptions
      const selectedRows = columnApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要导入的包装')
        return
      }
      this.loading = getLoading()
      const packages = selectedRows.map((item) => {
        return {
          packageNo: item.packageNo,
          poPackageUuid: item.uuid,
          warehouseInDetailUuid: item.warehouseInDetailUuid
        }
      })
      const params = {
        warehouseInUuid: this.warehouseInUuid,
        packages
      }
      addPackageToWarehouseIn(params)
        .then((res) => {
          this.$message.success('包装导入进仓单成功')
          this.loading.close()
          this.onClose()
        })
        .catch(() => {
          this.loading.close()
        })
    }
  }
}
</script>
<style lang="scss">
.add-cargo-form {
  .el-col {
    margin-bottom: 0!important;
  }
  .el-form-item__label {
    padding-bottom: 0;
  }
}
</style>
